import React from 'react';
import LocationsAdminSearchParams from './LocationsAdminSearchParams';
import ClientUnitService from '../../../Services/ClientUnitService';
import ClientUnitItem from '../../../Domain/ClientUnitItem';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';

export default class LocationsAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    // Deep-link seed for global record search (CD-5425), on the APOLLO location id - the grid
    // resolves a numeric CuName against CuSassieId, so the primary key would land nowhere.
    // Only when not embedded: props.Name means this page is scoped by its host already, and a
    // stray url parameter must not fight that. Standalone is "no Name", not "Name === ''": the menu
    // renders <LocationsAdmin /> with no props, so Name is undefined there, and testing for '' read
    // every menu visit as embedded and dropped the seed (the same idiom as TpClientLinkAdmin's isStandalone).
    const isStandalone = !props.Name;
    const seededCuName = isStandalone ? new URLSearchParams(window.location.search).get('CuName') : null;

    this.state = {
      searchItem: isStandalone
        ? seededCuName
          ? { CuName: seededCuName }
          : new LocationsAdminSearchParams()
        : { BravoClientNameOrApolloId: props.Name },
    };
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={ClientUnitItem}
          serviceFunction={ClientUnitService.GetListBySearching}
          convertDBItemsFunction={ClientUnitService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderBy={'CuId'}
          showSearchStrip={true}
          searchParamsType={LocationsAdminSearchParams}
          clickOnStartSearch={(searchItem) => this.setState({ searchItem })}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in different ids and names...'
          errorCode='LA31'
        />
      </div>
    );
  }
}
